<template>
	<div class="scan-container">
		<SearchHash/>
		<div style="margin: 2rem 0;" >Or upload a file</div>
		<Upload @submitted="setData"/>
		<Loader v-if="isLoading"/>
		<transition name="fade" appear> 
			<Results
				v-if="showResult"
				:fileDetails="fileDetails"
				:results="results"
			/>
		</transition>
	</div>
</template>

<script>
import SearchHash from '@/components/Actions/SearchHash.vue'
import Upload from '@/components/Actions/Upload.vue'
import Loader from '@/components/Actions/Loader.vue'
import Results from '@/components/Actions/Results.vue'

import axios from 'axios'

export default {
	name: 'Scan',
	components: {
    SearchHash,
		Upload,
		Loader,
		Results
	},
	data() {
		return {
			showResult: false,
			avs: null,
			fileDetails: {},
			results: [],
			isLoading: false
		}
	},
	methods: {
		setData(values) {
			this.avs = values.avs
			this.showResult = false
			if (!this.showResult && values.file && (this.avs.length > 0)) {
				this.isLoading = true
				this.$nextTick(() => {
					document.querySelector('#loader').scrollIntoView({behavior: "smooth" }) + 1
				})

				var formData = new FormData()

				formData.append('file', values.file)
				this.avs.map(item => {
					formData.append(item.name, item.checked)
				})
				axios.post(process.env.VUE_APP_BACK_URL + "/"+ this.$store.getters.getUserId +"/upload", formData, {
					headers: { "Content-Type": "multipart/form-data" }
				}).then((response) => {
					var data = response.data
					this.fileDetails = {
						name: data.fileName, 
						uploadDate: data.uploadTime,
						size: (data.fileSize/1048576).toFixed(3),
						MD5: data.hash.md5,
						SHA1: data.hash.sha1,
						SHA256: data.hash.sha256,
					}

					for (var key in data.avResponse) {
						this.results.push({
							"avName": key,
							"virus": data.avResponse[key]
						})
					}

					this.isLoading = false
					this.showResult = true
				}).catch(() => {
					console.log('error happened')
				})
			}
		},
		updateLoc() {
			this.$store.commit('changeLoc', true)
		}
	},
	mounted() {
		this.updateLoc()
	},
}
</script>